/** @jsx jsx */
import { Box, Grid, Heading, jsx } from 'theme-ui'
import { GatsbyImage } from 'gatsby-plugin-image'
import PackCardEmbed from '~/components/Pack/Card/Embed'
import PromoCard from '~/components/Generic/PromoCard'
import YoutubeVideo from '~/components/Generic/YoutubeVideo'

const MediaEmbed = ({ mediaEmbed, textAlign = 'left' }) => {
  const {
    caption,
    codeBlock,
    imageGallery,
    media,
    pack,
    packTitle,
    promo,
    video,
    videoAspectRatio,
  } = mediaEmbed

  return (
    <Box>
      {media && (
        <GatsbyImage image={media.gatsbyImageData} alt={media.description} />
      )}
      {imageGallery && (
        <Grid columns={[null, 2]}>
          {imageGallery.map((item, index) => (
            <Box key={`gallery-item-${index}`}>
              <GatsbyImage
                image={item.gatsbyImageData}
                alt={item.description}
              />
            </Box>
          ))}
        </Grid>
      )}
      {video && <YoutubeVideo id={video} aspectRatio={videoAspectRatio} />}
      {packTitle && pack && (
        <Heading as="h3" variant="title4" mb={2}>
          {packTitle}
        </Heading>
      )}
      {pack && <PackCardEmbed pack={pack} />}
      {promo && !pack && (
        <PromoCard
          cta={promo.cta}
          description={promo.description}
          image={promo.media}
          title={promo.title}
        />
      )}
      {codeBlock && (
        <Box
          dangerouslySetInnerHTML={{
            __html: codeBlock.childMarkdownRemark.html,
          }}
        />
      )}
      {caption && (
        <Box
          mt={1}
          color="greyDark"
          sx={{
            textAlign: textAlign,
            p: { m: 0, variant: 'text.description' },
          }}
          dangerouslySetInnerHTML={{
            __html: caption.childMarkdownRemark.html,
          }}
        />
      )}
    </Box>
  )
}

export default MediaEmbed
